var currentTab = 0; // Current tab is set to be the first tab (0)
showTab(currentTab); // Display the current tab

function showTab(n) {
  // This function will display the specified tab of the form ...
  var x = document.getElementsByClassName("tab");
  x[n].style.display = "block";
  // x[n].querySelector("img");

  var imageGet = x[n].querySelector("img");
  if (imageGet) {
    var srcAttribute = imageGet.getAttribute("src");
    var imgElement = document.querySelector(".size-img1");
    imgElement.setAttribute("src", srcAttribute);
    //console.log("test area.........", imageGet, srcAttribute);
  }
  // ... and fix the Previous/Next buttons:
  if (n == 0) {
    document.getElementById("prevBtn").style.display = "none";
    document.getElementById("nextBtn").parentElement.classList.add('initial');
    document.getElementById("nextBtn").classList.add('button');
  } else {
    document.getElementById("prevBtn").style.display = "flex";
    document.getElementById("nextBtn").parentElement.classList.remove('initial');
    document.getElementById("nextBtn").classList.remove('button');
  }
  if (n == x.length - 1) {
    document.getElementById("nextBtn").style.display = "none";
  } else {
    document.getElementById("nextBtn").style.display = "flex";
  }
}

$('input[name="band-size"]').change(function () {
  if (currentTab == 1) {
    if ($("input[name='band-size']:checked")) {
      $(".next-btn").css({ "pointer-events": "auto", opacity: "1" });
    }
  }
  document.querySelectorAll(".chart-items input").forEach(function (e) {
    e.checked = false;
  });
});

$('input[name="cup-size"]').change(function () {
  //console.log(currentTab, "currentTab inside change SEC");

  if (currentTab >= 2) {
    if ($("input[name='cup-size']:checked")) {
      $(".next-btn").css({ "pointer-events": "auto", opacity: "1" });
    }
  }
});

function nextPrev(n) {
  // console.log('n',n);
  // This function will figure out which tab to display
  var x = document.getElementsByClassName("tab");
  // Exit the function if any field in the current tab is invalid:
  if (n == 1 && !validateForm()) return false;
  // Hide the current tab:

  x[currentTab].style.display = "none";
  // Increase or decrease the current tab by 1:
  currentTab = currentTab + n;
  //console.log("currentTab", currentTab);

  if (currentTab == 0) {
    //console.log("test area zero level");
    $(".next-btn").css({ "pointer-events": "auto", opacity: "1" });
  }
  if (currentTab == 1) {
    var checkedRedioBtn = $("input[name='band-size']:checked").length;
    // var sizeRedioBtn = $("input[name='cup-size']:checked").length;
    // console.log('checkedRedioBtn',checkedRedioBtn ,sizeRedioBtn);
    // if(checkedRedioBtn == 0 || sizeRedioBtn == 0){
    if (checkedRedioBtn == 0) {
      $(".next-btn").css({ "pointer-events": "none", opacity: ".3" });
    } else {
      $(".next-btn").css({ "pointer-events": "auto", opacity: "1" });
    }
  }
  if (currentTab >= 2) {
    var sizeRedioBtn = $("input[name='cup-size']:checked").length;
    //console.log("updated sizeRedioBtn size", sizeRedioBtn);
    if (sizeRedioBtn == 0) {
      $(".next-btn").css({ "pointer-events": "none", opacity: ".3" });
    } else {
      $(".next-btn").css({ "pointer-events": "auto", opacity: "1" });
    }
  }

  var sizeImage = $(".size-banner-image img");
  var selectedSrc = $(".size-banner-image img").attr("src");
  // console.log('selectedSrc', selectedSrc);

  showTab(currentTab);
  var bandredioValue = $("input[name='band-size']:checked").val();
  var cup10redioValue = $("input[name='cup-size']:checked").val();
  var selectedSize = $("input[name='band-size']:checked").attr("data-size");
  // console.log(
  //   "selectedValue cup10",
  //   bandredioValue,
  //   cup10redioValue,
  //   selectedSize
  // );
  $("#result").text(bandredioValue + cup10redioValue);
  $("#result_cal").text(bandredioValue + cup10redioValue);
  $(".bust-size-chart").each(function (i) {
    var bandSize = $(this).attr("data-size");
    // console.log('bandSize',bandSize);
    if (bandSize == selectedSize) {
      // console.log('test area size',this);
      $(".bust-size-chart").hide();
      $(this).show();
      //$('.bust-size-chart').hide();
      if (n > 1) {
        var sizeRedioBtn = $("input[name='cup-size']:checked").length;
        //console.log("updated inside", sizeRedioBtn);
        if (sizeRedioBtn == 0) {
          $(".next-btn").css({ "pointer-events": "none", opacity: ".3" });
        } else {
          $(".next-btn").css({ "pointer-events": "auto", opacity: "1" });
        }
      }
    }
    if (n < 1) {
      if (currentTab == 1) {
        var checkedRedioBtn = $("input[name='band-size']:checked").length;
        // var sizeRedioBtn = $("input[name='cup-size']:checked").length;
        // console.log('checkedRedioBtn',checkedRedioBtn ,sizeRedioBtn);
        // if(checkedRedioBtn == 0 || sizeRedioBtn == 0){
        if (checkedRedioBtn == 0) {
          $(".next-btn").css({ "pointer-events": "none", opacity: ".3" });
        } else {
          $(".next-btn").css({ "pointer-events": "auto", opacity: "1" });
        }
      }
      if (currentTab >= 2) {
        var sizeRedioBtn = $("input[name='cup-size']:checked").length;
        // console.log('updated checkedRedioBtn',sizeRedioBtn);
        if (sizeRedioBtn == 0) {
          $(".next-btn").css({ "pointer-events": "none", opacity: ".3" });
        } else {
          $(".next-btn").css({ "pointer-events": "auto", opacity: "1" });
        }
      }
    }
  });
}

function validateForm() {
  // This function deals with validation of the form fields
  var x,
    y,
    i,
    valid = true;
  x = document.getElementsByClassName("tab");
  y = x[currentTab].getElementsByTagName("input");
  // console.log('test area y',x[currentTab]);
  var dataIndex = $(currentTab).attr;
  // A loop that checks every input field in the current tab:
  for (i = 0; i < y.length; i++) {
    // If a field is empty...
    if (y[i].value == null || y[i].value == "") {
      // add an "invalid" class to the field:
      y[i].className += " invalid";
      // and set the current valid status to false:
      valid = false;
    }
  }
  // If the valid status is true, mark the step as finished and valid:
  if (valid) {
    document.getElementsByClassName("bands")[currentTab].className += " finish";
  }
  return valid; // return the valid status
}
